import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useI18n } from '@/providers/i18n';
import ImgSlot from '@/ui/ImgSlot';

import styles from './CheckoutSuccess.module.css';

export default function CheckoutSuccess() {
  const { t } = useI18n();
  const ref = useMemo(
    () => Math.random().toString(36).slice(2, 10).toUpperCase(),
    [],
  );

  return (
    <section>
      <header className="page-h">
        <div>
          <span className="nano">/ STATUS / OK</span>
          <h1>{t('checkout.success')}</h1>
        </div>
        <span className="meta breathe">◦ TRANSMITTED</span>
      </header>
      <div className={styles.layout}>
        <div>
          <p className="hero-intro">{t('checkout.success.note')}</p>
          <div className={`line-row ${styles.refRow}`}>
            <span>REF</span>
            <span className="line" />
            <span>#{ref}</span>
          </div>
          <Link to="/" className={`btn btn-fill btn-arrow ${styles.cta}`}>
            RETURN TO INDEX
          </Link>
        </div>
        <ImgSlot label="TICKET / DIGITAL" className={styles.poster} />
      </div>
    </section>
  );
}
